var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useDimensions } from '../hooks/use-dimensions';
import { useComponentProps } from '../context/component-props-context';
import { LoadingLayout } from '../elements/loading-layout';
import { entityAsideMenuKey } from './entity-aside-menu';
import { useView } from '../hooks/use-view';
import { EntityConversationLayout } from './entity-conversation-layout';
import { EntityConversationBanner } from './entity-conversation-banner';
var cls = classNames('entity-conversations-Layout');
export var EntityConversationsLayoutDefaultProps = {
  mainView: 'explorer'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100%;\n  "], ["\n    height: 100%;\n  "])))
});
// 
var BannerContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n \n  "], ["\n \n  "])))
});
var BannerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 0 ", " ", ";\n  "], ["\n    padding: 0 ", " ", ";\n  "])), theme.UNIT(0), theme.UNIT(2)),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 0 ", " ", ";\n  "], ["\n    padding: 0 ", " ", ";\n  "])), theme.UNIT(0), theme.UNIT(3))
});
var CoversationsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    height: 80vh;\n  "], ["\n    height: 80vh;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityConversationsLayout',
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LoadingLayout: LoadingLayout,
  BannerContainer: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BannerContainerStyles),
  Banner: styled(EntityConversationBanner)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  Conversation: styled(EntityConversationLayout)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), CoversationsStyles)
};
export var EntityConversationsLayout = function (props) {
  var _a = useComponentProps(My.NAME, EntityConversationsLayoutDefaultProps, props),
    className = _a.className,
    children = _a.children,
    items = _a.items,
    mainView = _a.mainView;
  var _b = __read(useDimensions(), 2),
    bannerRef = _b[0],
    bannerInfo = _b[1];
  var initialSubView = entityAsideMenuKey(items === null || items === void 0 ? void 0 : items[0]);
  var activeSubView = useView(mainView, 'conversations', initialSubView).activeSubView;
  var activeItem = items.find(function (item) {
    return entityAsideMenuKey(item) === activeSubView;
  });
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, activeItem && entityAsideMenuKey(activeItem) && React.createElement(React.Fragment, null, React.createElement(My.BannerContainer, {
    ref: bannerRef
  }, React.createElement(My.Banner, {
    entity: activeItem
  })), React.createElement(My.Conversation, {
    entity: activeItem,
    className: className
  })), children);
};
EntityConversationsLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;